/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum CohortrendementTotDoublure {
    ZONDER_VERTRAGING = "Zonder vertraging",
    ZONDER_VERTRAGING_PROGNOSE = "Zonder vertraging (prognose)",
    GEDOUBLEERD = "Gedoubleerd",
    GEDOUBLEERD_PROGNOSE = "Gedoubleerd (prognose)"
}
